import { POISELECTED } from "../../actions/portal";

export default function(state = [], action) {
  switch (action.type) {
    case POISELECTED:
      return [action.payload, ...state];
    default:
  }

  return state;
}
